export var defaultProps = {
    className: '',
    disabled: false,
    loading: false,
    defaultChecked: false,
    width: 48,
    onChange: function (value, e) { },
    onClick: function (value, e) { },
};
